(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-date-night"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('.pdp-dn');
  if(!root) return;

  // Hero thumb swap
  var hero = root.querySelector('#dnHeroImg');
  root.querySelectorAll('.dn-thumb').forEach(function(t){
    t.addEventListener('click', function(e){
      e.preventDefault();
      root.querySelectorAll('.dn-thumb').forEach(function(x){x.classList.remove('active')});
      t.classList.add('active');
      if(hero) hero.src = t.dataset.src;
    });
  });

  // Subscription radio toggle
  var ctaPrice = root.querySelector('#dnCtaPrice');
  var stickyPrice = root.querySelector('#dnStickyPrice');
  root.querySelectorAll('.dn-opt').forEach(function(opt){
    opt.addEventListener('click', function(){
      root.querySelectorAll('.dn-opt').forEach(function(x){x.classList.remove('active')});
      opt.classList.add('active');
      var radio = opt.querySelector('input[type=radio]');
      if(radio) radio.checked = true;
      var price = opt.querySelector('.dn-opt-price');
      if(price && ctaPrice) ctaPrice.textContent = price.textContent;
      if(price && stickyPrice) stickyPrice.textContent = price.textContent;
    });
  });

  // Qty stepper
  var qty = root.querySelector('#dnQty');
  var qtyMin = root.querySelector('#dnQtyMin');
  var qtyPlus = root.querySelector('#dnQtyPlus');
  if(qtyPlus) qtyPlus.addEventListener('click', function(){ qty.value = (parseInt(qty.value, 10) || 1) + 1; });
  if(qtyMin) qtyMin.addEventListener('click', function(){ qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });

  // Sticky bar
  var sticky = root.querySelector('#dnStickybar');
  window.addEventListener('scroll', function(){
    if(window.scrollY > 50) sticky.classList.add('show');
    else sticky.classList.remove('show');
  }, {passive:true});

  // Final CTA + sticky CTA: scroll to top form
  root.querySelectorAll('[data-scroll-top]').forEach(function(b){
    b.addEventListener('click', function(e){
      e.preventDefault();
      var form = root.querySelector('#dn-pdp-form');
      if(form) form.scrollIntoView({behavior:'smooth', block:'start'});
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
